(() => {
  if (window.AurlonaSizeGuide?.init) {
    window.AurlonaSizeGuide.init();
    return;
  }

  const parseProductSize = label => {
    const source = String(label || '').split('|')[0];
    const widthMatch = source.match(/(\d+(?:\.\d+)?)\s*(?:["\u2033\u201d']|in)?\s*W\b/i);
    const heightMatch = source.match(/(\d+(?:\.\d+)?)\s*(?:["\u2033\u201d']|in)?\s*H\b/i);
    const dimensions = source.match(/(\d+(?:\.\d+)?)\s*(?:["\u2033\u201d']|in(?:ches)?|cm)?\s*[x\u00d7]\s*(\d+(?:\.\d+)?)/i);
    const values = widthMatch && heightMatch
      ? [Number(widthMatch[1]), Number(heightMatch[1])]
      : dimensions ? [Number(dimensions[1]), Number(dimensions[2])] : null;
    if (!values || values.some(value => !Number.isFinite(value) || value <= 0)) return null;
    const centimeters = /cm(?=\b|[x\u00d7]\s*[23]\s*$)/i.test(source) && !/["\u2033\u201d']|\bin(?:ches)?\b/i.test(source);
    return centimeters ? values.map(value => Math.round(value / 2.54 * 100) / 100) : values;
  };

  const productSizeEntry = label => {
    const size = parseProductSize(label);
    if (!size) return null;
    const text = String(label);
    const namedCount = text.match(/\bset\s*(?:of\s*)?([23])\b/i)
      || text.match(/\b([23])\s*[- ]?(?:pieces?|panels?)\b/i);
    const suffixCount = text.match(/[x\u00d7]\s*([23])\s*$/i);
    const hasDimensionsBeforeCount = suffixCount
      && (text.slice(0, suffixCount.index).match(/\d+(?:\.\d+)?/g) || []).length >= 2;
    const pieces = namedCount ? Number(namedCount[1])
      : hasDimensionsBeforeCount ? Number(suffixCount[1]) : 1;
    const ratio = size[0] / size[1];
    const shape = pieces > 1 ? 'artSets'
      : ratio > 1.75 ? 'panoramic' : ratio > 1.08 ? 'horizontal' : ratio < .92 ? 'vertical' : 'square';
    return { label: String(label), size, pieces, shape };
  };

  const initGuide = root => {
    if (!root || root.dataset.ready === 'true') return;
          root.dataset.ready = 'true';
    
          const productSizes = {
            horizontal: [[24, 20], [32, 24], [36, 24], [40, 30], [48, 32], [54, 36], [60, 40], [64, 48], [72, 48], [80, 60]],
            vertical: [[20, 24], [24, 32], [24, 36], [30, 40], [32, 48], [36, 54], [40, 60], [48, 64], [48, 72], [54, 72], [60, 80]],
            panoramic: [[36, 18], [48, 20], [60, 20], [60, 24], [72, 24], [80, 30], [90, 30], [100, 40]],
            square: [[24, 24], [30, 30], [36, 36], [40, 40], [48, 48], [60, 60], [72, 72]],
            artSets: [[20, 24], [24, 32], [30, 40], [32, 48], [36, 54], [40, 60]]
          };
    
          const furniture = {
            sofa: [84, 32], bed: [62, 48], wall: [96, 0], console: [48, 32],
            dining: [72, 30], fireplace: [54, 50], desk: [55, 30], bench: [48, 18]
          };
    
          const furnitureSvg = {
            sofa: '<ellipse class="sg-furniture-shadow" cx="60" cy="80" rx="49" ry="3"/><path class="sg-furniture-main" d="M11 72V55c0-6 4-10 10-10h78c6 0 10 4 10 10v17z"/><path class="sg-furniture-soft" d="M19 44V36c0-5 4-9 9-9h64c5 0 9 4 9 9v8zM19 48h82v17H19z"/><path class="sg-furniture-detail" d="M60 28v36M20 64h80M24 72v7M96 72v7"/>',
            bed: '<ellipse class="sg-furniture-shadow" cx="60" cy="80" rx="51" ry="3"/><path class="sg-furniture-main" d="M14 65V25c0-6 5-10 11-10h70c6 0 11 4 11 10v40h-7V31H21v34z"/><path class="sg-furniture-soft" d="M21 41V31c0-5 4-8 9-8h20c6 0 10 3 10 8v10zM60 41V31c0-5 4-8 10-8h20c5 0 9 3 9 8v10z"/><path class="sg-furniture-soft" d="M17 40h86l9 23H8z"/><path class="sg-furniture-main" d="M7 62h106v12H7z"/><path class="sg-furniture-detail" d="M17 40h86M12 56h96M60 41v15M17 69h86M18 74v5M102 74v5"/>',
            wall: '<path class="sg-wall-guide" d="M4 1h112M4 0v2M116 0v2"/>',
            console: '<ellipse class="sg-furniture-shadow" cx="60" cy="80" rx="48" ry="2.5"/><path class="sg-furniture-main" d="M8 8h104v8H8zM15 16h90v19H15zM17 35h10l-2 43h-9zM93 35h10l1 43h-9zM20 62h80v6H20z"/><path class="sg-furniture-soft" d="M19 19h38v12H19zM63 19h38v12H63z"/><path class="sg-furniture-detail" d="M60 17v17M35 25h6M79 25h6M22 35v27M98 35v27M25 68v10M95 68v10"/>',
            dining: '<ellipse class="sg-furniture-shadow" cx="60" cy="80" rx="50" ry="3"/><ellipse class="sg-furniture-main" cx="60" cy="39" rx="50" ry="12"/><path class="sg-furniture-soft" d="M17 35c0-10 5-16 12-16s12 6 12 16M79 35c0-10 5-16 12-16s12 6 12 16"/><path class="sg-furniture-detail" d="M35 48l-7 29M85 48l7 29M52 50v27M68 50v27"/>',
            fireplace: '<ellipse class="sg-furniture-shadow" cx="60" cy="80" rx="49" ry="3"/><path class="sg-furniture-main" d="M16 76V21h88v55H82V49c0-13-8-21-22-21s-22 8-22 21v27z"/><path class="sg-furniture-soft" d="M9 17h102v10H9z"/><path class="sg-furniture-detail" d="M28 28v48M92 28v48M39 54h42"/><path class="sg-furniture-soft" d="M60 70c-8-4-10-12-3-20 0 6 4 7 6 2 7 7 6 14-3 18z"/>',
            desk: '<ellipse class="sg-furniture-shadow" cx="60" cy="80" rx="51" ry="3"/><path class="sg-furniture-main" d="M8 35h104v8H8zM13 43h35v33H13z"/><path class="sg-furniture-soft" d="M19 49h23v9H19zM19 63h23v9H19zM68 14h28v21H68z"/><path class="sg-furniture-detail" d="M28 54h6M28 68h6M82 35v8M72 43h20M101 43v34M57 76V58h31v18M52 58h41"/>',
            bench: '<ellipse class="sg-furniture-shadow" cx="60" cy="80" rx="48" ry="3"/><path class="sg-furniture-main" d="M10 48c0-8 7-14 15-14h70c8 0 15 6 15 14v13H10z"/><path class="sg-furniture-soft" d="M16 44c0-4 4-7 9-7h70c5 0 9 3 9 7v8H16z"/><path class="sg-furniture-detail" d="M36 36v25M60 36v25M84 36v25M24 61v17M96 61v17"/>'
          };
    
          const sizeLabels = JSON.parse(root.querySelector('[data-sg-product-sizes]')?.textContent || '[]');
          const selection = JSON.parse(root.querySelector('[data-sg-product-selection]')?.textContent || '{}');
          const catalogSizes = sizeLabels.map(productSizeEntry).filter(Boolean);
          const initialProductSize = catalogSizes.find(entry => entry.label === selection.size) || catalogSizes[0];
          const detectedShape = initialProductSize?.shape || 'vertical';
          const detectedPieces = initialProductSize?.pieces || 1;
          const state = { furniture: 'sofa', shape: detectedShape, frame: 'framed', pieces: detectedPieces };
          const wall = root.querySelector('[data-sg-wall]');
          const artWrap = root.querySelector('[data-sg-art-wrap]');
          const art = root.querySelector('[data-sg-art]');
          const furnitureWrap = root.querySelector('[data-sg-furniture-wrap]');
          const furnitureView = root.querySelector('[data-sg-furniture-view]');
          const widthInput = root.querySelector('input[id^="sg-furniture-width-"]');
          const sizeSelect = root.querySelector('[data-sg-size]');
          const pieceGroup = root.querySelector('[data-sg-piece-group]');
          const recommended = root.querySelector('[data-sg-recommended]');
          let currentSizes = [];
    
          const sizeText = ([width, height]) => `${height}\u2033H \u00D7 ${width}\u2033W`;
          const currentPieceCount = () => state.shape === 'artSets' ? state.pieces : 1;
    
          function setPressed(container, value) {
            container.querySelectorAll('button[data-value]').forEach(button => {
              button.setAttribute('aria-pressed', String(button.dataset.value === String(value)));
            });
          }
    
          function bestSize(sizes) {
            const count = currentPieceCount();
            const furnitureWidth = Math.max(24, Math.min(240, Number(widthInput.value) || 84));
            const candidates = sizes.map(size => {
              const ratio = size[0] / size[1];
              const target = (ratio >= 1.25 ? .675 : ratio >= .8 ? .6 : .55) * furnitureWidth;
              const coverage = size[0] * count + (count - 1) * 3;
              return { size, coverage, target, delta: Math.abs(coverage - target) };
            });
            // Keep the furniture proportion as the upper target. When product sizes
            // straddle it, use the closer size below it instead of rounding up.
            const fitting = candidates.filter(candidate => candidate.coverage <= candidate.target);
            return (fitting.length ? fitting : candidates).reduce((best, candidate) => {
              return !best || candidate.delta < best.delta ? candidate : best;
            }, null).size;
          }
    
          function refreshSizes(selectRecommended = false, preferredSize = null) {
            const previous = preferredSize || currentSizes[Number(sizeSelect.value)];
            const matchingEntries = catalogSizes.filter(entry => entry.shape === state.shape && entry.pieces === currentPieceCount());
            currentSizes = matchingEntries.length
              ? matchingEntries.map(entry => entry.size).filter((size, index, sizes) => sizes.findIndex(item => item[0] === size[0] && item[1] === size[1]) === index)
              : productSizes[state.shape];
            const sourceLabel = root.querySelector('[data-sg-source-label]');
            if (sourceLabel) sourceLabel.textContent = matchingEntries.length ? sourceLabel.dataset.productLabel : sourceLabel.dataset.exampleLabel;
            const best = bestSize(currentSizes);
            const bestIndex = currentSizes.findIndex(size => size[0] === best[0] && size[1] === best[1]);
            const previousIndex = previous ? currentSizes.findIndex(size => size[0] === previous[0] && size[1] === previous[1]) : -1;
            sizeSelect.innerHTML = '';
            currentSizes.forEach((size, index) => {
              const option = document.createElement('option');
              option.value = String(index);
              option.textContent = `${sizeText(size)}${index === bestIndex ? ' \u2014 RECOMMENDED' : ''}`;
              sizeSelect.appendChild(option);
            });
            sizeSelect.value = String(selectRecommended || previousIndex < 0 ? bestIndex : previousIndex);
            recommended.replaceChildren();
            const label = document.createElement('span');
            label.textContent = 'Recommended for this furniture:';
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.index = String(bestIndex);
            button.textContent = `${sizeText(best)} \u2197`;
            button.setAttribute('aria-label', `Select recommended size ${sizeText(best)}`);
            recommended.append(label, button);
            render();
          }
    
          function render() {
            if (!currentSizes.length) return;
            const size = currentSizes[Number(sizeSelect.value)] || currentSizes[0];
            const count = currentPieceCount();
            const furnitureWidth = Math.max(24, Math.min(240, Number(widthInput.value) || 84));
            const furnitureHeight = furniture[state.furniture][1];
            const frameAllowance = state.frame === 'framed' ? .2 : 0;
            const artHeight = size[1] + frameAllowance;
            const groupWidth = (size[0] + frameAllowance) * count + (count - 1) * 3;
            const wallWidth = wall.clientWidth || 640;
            const isWall = state.furniture === 'wall';
            const isCompact = wallWidth < 480;
            const sceneGap = isCompact ? 4 : 2;
            const sceneWidth = Math.max(furnitureWidth, groupWidth);
            const sceneHeight = isWall ? artHeight : furnitureHeight + sceneGap + artHeight;
            const sidePadding = isCompact ? 24 : 38;
            const topPadding = isCompact ? 24 : 34;
            const bottomPadding = isCompact ? 28 : 36;
            const wallArtGap = isCompact ? 36 : 42;
            const widthBudget = Math.max(180, wallWidth - sidePadding * 2);
            const widthScale = widthBudget / sceneWidth;
            const wallHeight = wall.clientHeight || Math.round(wallWidth / (isCompact ? 4 / 3 : 1.9));
    
            // Keep the viewport fixed and fit the selected composition inside its safe area.
            const floorMin = wallHeight * .14;
            const floorMax = wallHeight * .31;
            const heightBudget = isWall
              ? Math.max(80, wallHeight - topPadding - floorMin - wallArtGap)
              : Math.max(120, wallHeight - topPadding - bottomPadding);
            const scale = Math.min(widthScale, heightBudget / sceneHeight);
            const furniturePixelWidth = furnitureWidth * scale;
            const furniturePixelHeight = furnitureHeight * scale;
            const usedHeight = sceneHeight * scale;
            const verticalSlack = Math.max(0, heightBudget - usedHeight);
            const baseFurnitureBottom = bottomPadding + verticalSlack * .42;
            const floorByFurniture = isWall
              ? floorMin
              : baseFurnitureBottom
                + furniturePixelHeight * .28
                + Math.min(wallHeight * .06, furniturePixelWidth * .055);
            const floorHeight = Math.max(floorMin, Math.min(floorMax, floorByFurniture));
            const wallGuideHeight = 10;
            const furnitureBottom = isWall ? floorHeight - wallGuideHeight / 2 : baseFurnitureBottom;
            const wallArtAreaHeight = Math.max(0, wallHeight - topPadding - floorHeight - wallArtGap);
            const artBottom = isWall
              ? floorHeight + wallArtGap + Math.max(0, (wallArtAreaHeight - artHeight * scale) / 2)
              : furnitureBottom + furniturePixelHeight + sceneGap * scale;
    
            wall.style.setProperty('--sg-floor-height', `${floorHeight}px`);
            artWrap.style.width = `${groupWidth * scale}px`;
            artWrap.style.height = `${artHeight * scale}px`;
            artWrap.style.top = 'auto';
            artWrap.style.bottom = `${artBottom}px`;
            art.style.gap = `${3 * scale}px`;
            art.className = `sg-art is-${state.frame}`;
            art.replaceChildren(...Array.from({ length: count }, () => {
              const panel = document.createElement('span');
              panel.className = 'sg-panel';
              return panel;
            }));
    
            furnitureWrap.classList.toggle('is-wall', isWall);
            furnitureWrap.style.width = `${furniturePixelWidth}px`;
            furnitureWrap.style.height = `${isWall ? wallGuideHeight : Math.max(2, furniturePixelHeight)}px`;
            furnitureWrap.style.bottom = `${furnitureBottom}px`;
            furnitureView.setAttribute('viewBox', isWall ? '0 0 120 2' : '0 0 120 85');
            furnitureView.innerHTML = furnitureSvg[state.furniture];
    
            root.querySelector('[data-sg-art-width]').textContent = `${count > 1 ? 'Group ' : ''}${Math.round(groupWidth * 10) / 10}\u2033 W`;
            root.querySelector('[data-sg-art-height]').textContent = `${Math.round(artHeight * 10) / 10}\u2033 H`;
            root.querySelector('[data-sg-furniture-width]').textContent = `${furnitureWidth}\u2033 W`;
            root.querySelector('[data-sg-caption]').textContent = `${sizeText(size)}${count > 1 ? ' each' : ''} \u00B7 ${count === 1 ? 'Single' : `Set of ${count}`} \u00B7 ${isWall ? 'Wall' : 'Furniture'} ${furnitureWidth}\u2033 wide`;
          }
    
          root.querySelector('[data-sg-furniture-choices]').addEventListener('click', event => {
            const button = event.target.closest('button[data-value]');
            if (!button) return;
            state.furniture = button.dataset.value;
            widthInput.value = String(furniture[state.furniture][0]);
            setPressed(event.currentTarget, state.furniture);
            refreshSizes(false);
          });
    
          root.querySelector('[data-sg-shape-choices]').addEventListener('click', event => {
            const button = event.target.closest('button[data-value]');
            if (!button) return;
            state.shape = button.dataset.value;
            state.pieces = state.shape === 'artSets' ? (detectedPieces > 1 ? detectedPieces : 2) : 1;
            pieceGroup.hidden = state.shape !== 'artSets';
            setPressed(event.currentTarget, state.shape);
            setPressed(root.querySelector('[data-sg-piece-choices]'), state.pieces);
            refreshSizes(true);
          });
    
          root.querySelector('[data-sg-piece-choices]').addEventListener('click', event => {
            const button = event.target.closest('button[data-value]');
            if (!button) return;
            state.pieces = Number(button.dataset.value);
            setPressed(event.currentTarget, state.pieces);
            refreshSizes(true);
          });
    
          root.querySelector('[data-sg-frame-choices]').addEventListener('click', event => {
            const button = event.target.closest('button[data-value]');
            if (!button) return;
            state.frame = button.dataset.value;
            setPressed(event.currentTarget, state.frame);
            render();
          });
    
          root.querySelectorAll('[data-sg-step]').forEach(button => {
            button.addEventListener('click', () => {
              widthInput.value = String(Math.max(24, Math.min(240, (Number(widthInput.value) || 84) + Number(button.dataset.sgStep))));
              refreshSizes(false);
            });
          });
    
          widthInput.addEventListener('input', () => {
            if (widthInput.value !== '') refreshSizes(false);
          });
    
          widthInput.addEventListener('change', () => {
            widthInput.value = String(Math.max(24, Math.min(240, Number(widthInput.value) || 84)));
            refreshSizes(false);
          });
    
          sizeSelect.addEventListener('change', render);
          recommended.addEventListener('click', event => {
            const button = event.target.closest('button[data-index]');
            if (!button) return;
            sizeSelect.value = button.dataset.index;
            render();
          });
    
          setPressed(root.querySelector('[data-sg-furniture-choices]'), state.furniture);
          setPressed(root.querySelector('[data-sg-shape-choices]'), state.shape);
          setPressed(root.querySelector('[data-sg-piece-choices]'), state.pieces);
          setPressed(root.querySelector('[data-sg-frame-choices]'), state.frame);
          pieceGroup.hidden = state.shape !== 'artSets';
          if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(render).observe(wall);
          } else {
            window.addEventListener('resize', render, { passive: true });
          }
          const resetProductRecommendation = () => {
            const productArea = root.closest('[id^="product-info-"]');
            let selectedLabel = selection.size;
            if (productArea) {
              const swatch = Array.from(productArea.querySelectorAll('.globo-swatch-product-detail .swatch--gl')).find(element =>
                element.querySelector('.name-option')?.getAttribute('data-name')?.toLowerCase() === String(selection.optionName || 'Size').toLowerCase()
              );
              const selectedSwatch = swatch?.querySelector('input[type="radio"]:checked, select');
              const nativeValue = productArea.querySelector('hdt-variant-picker [name="option' + selection.optionPosition + '"]');
              selectedLabel = selectedSwatch?.value || nativeValue?.value || selectedLabel;
            }
            const entry = catalogSizes.find(item => item.label === selectedLabel) || initialProductSize;
            state.furniture = 'sofa';
            widthInput.value = String(furniture.sofa[0]);
            state.shape = entry?.shape || detectedShape;
            state.pieces = entry?.pieces || detectedPieces;
            setPressed(root.querySelector('[data-sg-furniture-choices]'), state.furniture);
            setPressed(root.querySelector('[data-sg-shape-choices]'), state.shape);
            setPressed(root.querySelector('[data-sg-piece-choices]'), state.pieces);
            pieceGroup.hidden = state.shape !== 'artSets';
            refreshSizes(true);
          };

          root.addEventListener('aurlona:size-guide:open', resetProductRecommendation);
          refreshSizes(true);
  };

  const initDialog = dialog => {
    const trigger = document.querySelector('[aria-controls="' + dialog.id + '"]');
          if (!trigger || !dialog || trigger.dataset.sgReady === 'true') return;
          trigger.dataset.sgReady = 'true';
    
          const productArea = trigger.closest('[id^=product-info-]') || document.body;
          const isUsableTarget = element => {
            if (!element || !element.getClientRects().length) return false;
            const style = getComputedStyle(element);
            return style.display !== 'none' && style.visibility !== 'hidden';
          };
          const placeTrigger = () => {
            const globoSizeLabel = productArea.querySelector('.globo-swatch-product-detail .swatch--gl > .name-option[data-name=Size]');
            const nativeSizeLabel = productArea.querySelector('.hdt-product-form__input.is-style-size > .hdt-product-form__label');
            const target = isUsableTarget(globoSizeLabel)
              ? globoSizeLabel
              : isUsableTarget(nativeSizeLabel) ? nativeSizeLabel : null;
            if (!target) return false;
    
            productArea.querySelectorAll('.aurlona-sg-inline-host').forEach(element => {
              if (element !== target) element.classList.remove('aurlona-sg-inline-host');
            });
            target.classList.add('aurlona-sg-inline-host');
            if (trigger.parentElement !== target) target.appendChild(trigger);
            return true;
          };
    
          placeTrigger();
          if (typeof MutationObserver !== 'undefined') {
            const placementObserver = new MutationObserver(() => requestAnimationFrame(placeTrigger));
            placementObserver.observe(productArea, { childList: true, subtree: true });
          }
          let placementAttempt = 0;
          const placementTimer = setInterval(() => {
            placementAttempt += 1;
            if (placeTrigger() || placementAttempt >= 25) clearInterval(placementTimer);
          }, 400);
    
          const openDialog = event => {
            event.preventDefault();
            event.stopPropagation();
            requestAnimationFrame(() => {
              if (dialog.open) return;
              dialog.querySelector('.aurlona-sg-dialog-inner')?.scrollTo(0, 0);
              dialog.querySelector('.aurlona-size-guide')?.dispatchEvent(new Event('aurlona:size-guide:open'));
              if (typeof dialog.showModal === 'function') {
                try { dialog.showModal(); } catch (error) { dialog.setAttribute('open', ''); }
              } else {
                dialog.setAttribute('open', '');
              }
            });
          };
          const closeDialog = () => {
            if (typeof dialog.close === 'function' && dialog.open) dialog.close();
            else dialog.removeAttribute('open');
          };
    
          trigger.addEventListener('click', openDialog);
          dialog.querySelector('[data-sg-close]')?.addEventListener('click', closeDialog);
          dialog.addEventListener('click', event => { if (event.target === dialog) closeDialog(); });
  };

  const init = () => {
    document.querySelectorAll('.aurlona-size-guide').forEach(initGuide);
    document.querySelectorAll('.aurlona-sg-dialog').forEach(initDialog);
  };

  window.AurlonaSizeGuide = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();